<template lang="html">
  <div class="documents-table-correspondent-details">
    <template v-if="document.selfExchange">
      <div>{{$t('Конвертация валюты')}}</div>
      <div style="padding-top: 5px; font-size: 85%;">
        <strong>
          <document-beneficiary-link
            class="sender-beneficiary"
            :title-searching="$t('Идет поиск...')"
            :title-owner-title="$t('ваш аккаунт')"
            :title-balance="$t('Баланс')"
            :beneficiary="document.sender"
            :title-search="$t('Поиск по корреспонденту')"
            :search-link="document.historyBeneficiarySearchUrl">{{ document.sender }}
          </document-beneficiary-link>
          &#10230;
          <document-beneficiary-link
            :title-searching="$t('Идет поиск...')"
            :title-owner-title="$t('ваш аккаунт')"
            :title-balance="$t('Баланс')"
            :beneficiary="document.receiver"
            :title-search="$t('Поиск по корреспонденту')"
            :search-link="document.historyBeneficiarySearchUrl">{{ document.receiver }}
          </document-beneficiary-link>
        </strong>
      </div>
    </template>
    <template v-if="!document.selfExchange">
      <template
        v-if="!document.outgoing && isWire">{{$t('Входящий платеж')}}</template>
      <template v-if="(document.outgoing || !isWire)">{{ document.channel }}</template>
      <div v-if="isWireWithDetails" class="wire-corr-details">
        <strong>{{ document.corrDetails.corrName}}<br/>
          <document-beneficiary-link
            :title-searching="$t('Идет поиск...')"
            :title-owner-title="$t('ваш аккаунт')"
            :title-balance="$t('Баланс')"
            :beneficiary="document.corrDetails.corrBankAccount"
            :title-search="$t('Поиск по корреспонденту')"
            :search-link="document.historyBeneficiarySearchUrl">{{ document.beneficiary }}
          </document-beneficiary-link>
          <br/>{{ document.corrDetails.corrBankName}}</strong>
      </div>
      <div v-if="isSepaWithDetails" class="wire-corr-details">
        <strong>
          <document-beneficiary-link
            :title-searching="$t('Идет поиск...')"
            :title-owner-title="$t('ваш аккаунт')"
            :title-balance="$t('Баланс')"
            :beneficiary="document.meta.IBAN"
            :title-search="$t('Поиск по корреспонденту')"
            :search-link="document.historyBeneficiarySearchUrl">{{ document.beneficiary }}
          </document-beneficiary-link>
          <br/>{{ document.meta.beneficiaryName}}
          <br/>{{ document.meta.bankName}}
        </strong>
      </div>
      <template v-if="!isWireWithDetails && isCorrespondentNotEmpty && !isSepaWithDetails">
        <div style="padding-top: 5px;">
          <small><strong>
            <document-beneficiary-link
              :title-searching="$t('Идет поиск...')"
              :title-owner-title="$t('ваш аккаунт')"
              :title-balance="$t('Баланс')"
              :beneficiary="document.beneficiary"
              :title-search="$t('Поиск по корреспонденту')"
              :search-link="document.historyBeneficiarySearchUrl">{{ document.beneficiary }}
            </document-beneficiary-link>
          </strong></small>
        </div>
      </template>
      <div v-if="isWire && document.description" class="wire-corr-desc">&laquo;{{document.description}}&raquo;
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import DocumentBeneficiaryLink from '@/views/pages/finance/history/DocumentBeneficiaryLink.vue';

@Component({
  components: {DocumentBeneficiaryLink},
  name: 'document-beneficiary-details',
})
export default class DocumentBeneficiaryDetails extends Vue {
  @Prop({required: true})
  document: any

  get isPrepaid() {
    return Boolean(this.document.prepaid)
  }

  get isCapitalistSystem(): boolean {
    return this.document.beneficiary == 'Capitalist System';
  }

  get isSepa(): boolean {
    return this.document.channelType == 'sepaifx';
  }

  get isWire(): boolean {
    return this.document.channelType == 'wire';
  }

  get isWireWithDetails(): boolean {
    return this.isWire && this.document.corrDetails;
  }

  get isSepaWithDetails(): boolean {
    return this.isSepa && this.document.meta;
  }

  get isCorrespondentNotEmpty(): boolean {
    return this.document.beneficiary && (this.document.beneficiary != this.document.channel);
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "Конвертация валюты": "Currency exchange",
    "Идет поиск...": "Searching...",
    "ваш аккаунт": "your account",
    "Баланс": "Balance",
    "Поиск по корреспонденту": "Search by correspondent",
    "Входящий платеж": "Incoming payment"
  }
}
</i18n>
